import React from 'react';
import './Navbar.css';

const Navbar = () => {
  return (
    <nav className="navbar">
      <div className="navbar-container">
        <image src={require('../assets/innodata-logo-rectangle.png')} alt="Innodata Logo" className="logo-image" />
        <a href="#overview" className="navbar-logo">
        
        </a>
        <ul className="nav-menu">
          <li className="nav-item">
            <a href="#overview" className="nav-links">Overview</a>
          </li>
          <li className="nav-item">
            <a href="#projects" className="nav-links">Projects</a>
          </li>
          <li className="nav-item">
            <a href="#services" className="nav-links">Our Services</a>
          </li>
          <li className="nav-item">
            <a href="#about" className="nav-links">About Us</a>
          </li>
          
           <li className="nav-item">
            <a href="#ourteam" className="nav-links">Our Team</a>
          </li>
          <li className="nav-item">
            <a href="#contactus" className="nav-links">Contact Us</a>
          </li>
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;